import React from 'react';
import { Radio } from 'components';

import { Option } from '../fleet-rule-utils';

import styles from '../fleet-rule.module.scss';

export interface FleetRadioGroupProps {
	disabled?: boolean;
	handleChange: (e) => void;
	value: string;
	options: Option[];
}

export const FleetRadioGroup = ({ handleChange, value, options, disabled = false }: FleetRadioGroupProps) => (
	<div className={styles['radio-group']}>
		<Radio.Group onChange={handleChange} value={value}>
			{options.map(option => (
				<Radio className={styles['radio-item']} disabled={disabled} key={option.value} value={option.value}>
					{option.key}
				</Radio>
			))}
		</Radio.Group>
	</div>
);
